import { useNavigate } from "react-router-dom";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Sparkles, XCircle } from "lucide-react";

/**
 * Subscription error page shown when subscription activation fails.
 * Displays error state with navigation back to home.
 *
 * No props required - self-contained page.
 * User will adjust messages later if needed.
 */
export const SubscriptionErrorPage = (): JSX.Element => {
    const navigate = useNavigate();

    const handleGoHome = () => {
        navigate("/");
    };

    return (
        <div className="min-h-screen flex items-center justify-center p-4">
            <div className="max-w-md w-full bg-background border border-border rounded-xl shadow-sm p-6">
                {/* Header with Carriapp Plus badge */}
                <div className="flex flex-col items-center text-center mb-6">
                    <Badge
                        variant="default"
                        className="w-fit flex items-center gap-1 text-xs mb-4"
                    >
                        <Sparkles size={10} /> Carriapp Plus
                    </Badge>

                    {/* Error heading with icon */}
                    <div className="flex items-center gap-2 mb-2">
                        <XCircle
                            size={28}
                            className="text-destructive shrink-0"
                        />
                        <h1 className="text-2xl font-bold leading-tight text-foreground">
                            Algo salió mal
                        </h1>
                    </div>

                    {/* Error message */}
                    <p className="text-base text-muted-foreground mt-2">
                        No pudimos completar la activación de tu suscripción en este momento.
                        Por favor intenta más tarde.
                    </p>
                </div>

                {/* Highlight box */}
                <div className="bg-primary/10 rounded-lg p-3 text-sm font-medium text-center text-primary mb-6">
                    ¿Necesitas ayuda? Escríbenos para asistirte
                </div>

                {/* CTA button */}
                <Button
                    variant="default"
                    size="lg"
                    className="w-full"
                    onClick={handleGoHome}
                >
                    Volver a Carriapp
                </Button>
            </div>
        </div>
    );
};